// this translates our coordinates from N/W to +/- values.
export function getCoorByDir(coor, dir) {
  switch (dir) {
    case "N":
      return coor;

    case "W":
      return coor * -1;

    case "E":
      return coor;

    case "S":
      return coor * -1;
      
    default:
      return 0; //Number(str.substring(0, str.length - 1)) // 100;
  }
}

export function getCoor (coor) {
  if(isUnknown(coor)) 
    return 0

  const character = coor.charAt(coor.length-1)
  const number = coor.substring(0, coor.length-1)

  return ["N","E"].includes(character) 
    ? Math.abs(number) + ""
    : `-${Math.abs(number)}` + ""
}

export function getColor(status) {
  if (isUnknown(status)) return "rgba(130,130,130,1)";

  const normalisedStatus = status.toUpperCase()  

  switch (normalisedStatus) {
    case 5:
    case "UNKNOWN":
    case 3:
    case "IDLING":
      return "rgb(255,165,0)";

    case 2:
    case "STATIONARY":
      return "#EF1E1E";
      
    case 1:
    case "MOVING":
      return "#18a31b";

    case "OFFLINE":
    case 4:
    default:
      return "rgba(130,130,130,1)";
  }
}

export function getStatus(status) {
  if (isUnknown(status)) return 5;
  switch (status) {
    case "MOVING":
      return 1;

    case "STATIONARY":
      return 2;

    case "IDLING":
      return 3;

    case "UNKNOWN": 
      return 5;

    case "OFFLINE":
    default:
      return 4;
  }
}

export function isUnknown(attr) {
  return Boolean(attr === "unknown" || !attr);
}

// Accepts vehicle object and returns the default device for that vehicle
export function findDefaultDevice(vehicle) {
  if (!vehicle) return

  return vehicle.devices.find(device => device.is_defaultdevice == true);
}

export function checkNested(obj /*, level1, level2, ... levelN*/) {
  var args = Array.prototype.slice.call(arguments, 1);

  for (var i = 0; i < args.length; i++) {
    if (!obj || !obj.hasOwnProperty(args[i])) {
      return false;
    }
    obj = obj[args[i]];
  }
  return true;
}

export function formatBytes(bytes, decimals = 0) {
  if (!+bytes) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

/**
 * Parses a string 
 * @param {string} csv - string contents of a csv file
 * @returns Parsed array of data
 */
export function parseCSV (csv) {
	// split out csv by new line
	let lines = csv.split('\n')
  // get our headers for the values
  let headers = lines[0].split(',')
  const response = []
  
  // for each line, we iterate through each header and set the value, before adding 
  // it to the response set
  for(let x = 1; x < lines.length - 1; x++) {
  	let row = lines[x].split(',')
  	let item = {}
  	for(let i = 0; i < headers.length; i++) {
    	item[headers[i]] = row[i]
    }
    response.push(item)
  }
	return response
}

export function convertToMB(bytes) {
  return (bytes / (1024*1024)).toFixed(2);
}

export function formatTZOffset(offsetInMins) {

  if(!offsetInMins) {
    return `+00:00`
  }

	const val = Number.parseInt(offsetInMins)
  const mins = Math.abs(val)
  
  let hours = Math.floor(mins / 60)
  hours = hours < 10
  	? `0${hours}`
    : hours
    
  let remainingMins = mins % 60
  remainingMins = remainingMins < 10
  	? `0${remainingMins}`
    : remainingMins
    
  const sign = val < 0 
  	? '-'
    : '+'
    
  return `${sign}${hours}:${remainingMins}`
}

// Accepts 2 strings, current version running on a given DVR and an upper limit
// and determines if the current version exceeds the limit
export function checkIfVersionIsAboveLimit (current, limit) {
  const _current = current.split('.');
  const _limit = limit.split('.');

  for (var i = 0; i < _current.length; i++) {
    const a = ~~_current[i];
    const b = ~~_limit[i];

    if (a > b) return true;
    if (a < b) return false;
  }

  return false;
}

export function addTimeOffsets(a, b, flip = false) {
  if (!a || !b) return '';
  let mins = 0

  // if one of our offsets seems incorrect
  if(a.length != 6 || b.length != 6) {
  	return '+00:00'
  }
  
  try {
    mins += [...a][0] == '+'
      ? Number.parseInt(`${[...a][1]}${[...a][2]}`) * 60
      : Number.parseInt(`-${[...a][1]}${[...a][2]}`) * 60
      
    mins += [...b][0] == '+'
      ? Number.parseInt(`${[...b][1]}${[...b][2]}`) * 60
    : Number.parseInt(`-${[...b][1]}${[...b][2]}`) * 60
    
    mins += [...b][0] == '+'
      ? Number.parseInt(`${[...b][4]}${[...b][5]}`)
    : Number.parseInt(`-${[...b][4]}${[...b][5]}`)
    
    mins += [...a][0] == '+'
      ? Number.parseInt(`${[...a][4]}${[...a][5]}`)
      : Number.parseInt(`-${[...a][4]}${[...a][5]}`)
      
    let sign = mins > 0 
      ? '+'
      : '-'

    // if we want the sign flipped, we flip it here
    sign = flip 
      ? sign == '+'
        ? '-'
        : '+'
      : sign
      
    let hours = Math.floor(Math.abs(mins) / 60)
    hours = hours > 9
      ? `${hours}`
      : `0${hours}`
      
    let minutes = Math.abs(mins) % 60
    minutes = minutes > 9
      ? `${minutes}`
      : `0${minutes}`
    
    return `${sign}${hours}:${minutes}`
  } catch {
    return '+00:00'
  }
}